/* oxlint-disable typescript/no-explicit-any -- attributes can be any type */
// Parse attribute block {key=value ...}
// Handles nested braces with depth tracking
// Returns parsed attributes and new position, or null if parsing fails

import { parseAttributes } from './parse-attributes'

export interface AttributeBlockResult {
  ok: boolean
  pos: number
  attributes: Record<string, any>
}

export function parseAttributeBlock(
  str: string,
  pos: number,
  max: number,
): AttributeBlockResult {
  const result: AttributeBlockResult = {
    ok: false,
    pos,
    attributes: {},
  }

  // Check for opening {
  if (pos >= max || str.charCodeAt(pos) !== 0x7b /* { */) return result

  const attrStart = pos + 1
  let depth = 1
  pos++

  // Track depth to handle nested braces
  while (pos < max && depth > 0) {
    const code = str.charCodeAt(pos)
    if (code === 0x7b /* { */) depth++
    else if (code === 0x7d /* } */) depth--

    if (depth > 0) pos++
  }

  // Check if we found matching closing brace
  if (depth !== 0) return result

  // Extract and parse attributes
  const attrStr = str.slice(attrStart, pos)
  result.attributes = parseAttributes(attrStr)
  result.pos = pos + 1 // Skip closing }
  result.ok = true

  return result
}
